import React from "react";

const Kit_Pdf = () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      {isIOS ? (
        <div className="flex items-center justify-center h-[80vh]">
          <a
            href={`${process.env.PUBLIC_URL}/oyskit.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg text-lg"
          >
            Open PDF
          </a>
        </div>
      ) : (
        <iframe
          src={`${process.env.PUBLIC_URL}/oyskit.pdf`}
          className="w-full h-[90vh] border rounded-lg bg-white"
          title="PDF Viewer"
        />
      )}
    </div>
  );
};

export default Kit_Pdf;
